import appConfig from "configs/app.config";
import { invokeOmsService, queryOmsService } from "./apiService";
import { buildQueryParams } from "../utils/helper";


const getRequestProcessorOrdersByInternalStatus = async (payload = {}) => {
   const queryString = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "description",
    orderBy: "asc",
  });
  const internalStatus = payload.internalStatus;
  let url =
    appConfig.v2.getRequestProcessorOrdersByInternalStatus.replace("{status}", internalStatus) +
    `?${queryString}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await queryOmsService(requestParams);
};

const getNewRequestProcessorDocuments = async (payload = {}) => {
  const queryString = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "description",
    orderBy: "asc",
  });
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getNewRequestProcessorDocuments+ `?${queryString}`,
  };

  return await invokeOmsService(requestParams);
};


const getRequestorOrdersByRequestStatus = async (payload = {}) => {
  const queryString = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "description",
    orderBy: "asc",
  });
  const internalStatus = payload.internalStatus;
  let url =
    appConfig.v2.getRequestorOrdersByRequestStatus.replace(
      "{status}",
      internalStatus
    ) + `?${queryString}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await queryOmsService(requestParams);
};

const getAllRequest = async (payload = {}) => {
  const queryString = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "description",
    orderBy: "asc",
  });
  let url = appConfig.v2.getAllRequest + `?${queryString}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await queryOmsService(requestParams);
};

const getBulkAssignmentOrders = async (payload = {}) => {
  const queryString = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "description",
    orderBy: "asc",
  });
  const internalStatus = payload.internalStatus;
  let url =
    appConfig.v2.documentRequest.getBulkAssignmentOrders.replace(
      "{status}",
      internalStatus
    ) + `?${queryString}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await queryOmsService(requestParams);
};

const getRequestorOrdersWithFilesByRequestStatus = async (payload = {}) => {
  const queryString = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "description",
    orderBy: "asc",
  });
  const internalStatus = payload.internalStatus;
  let url =
    appConfig.v2.getRequestorOrdersWithFilesByRequestStatus.replace(
      "{status}",
      internalStatus
    ) + `?${queryString}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await queryOmsService(requestParams);
};


const updateOrderSupportRequestProcessor = async (id) => {
  try{
    const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.updateRequestProcessort.replace("{orderId}", id),
  };
  return await invokeOmsService(requestParams);
  } catch(error){
    console.log(error)
  }
};

const setRequesterSupportMessagesRead = async (id) => {
  try{
    const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.setRequesterSupportMessagesRead.replace("{orderId}", id),
  };
  return await invokeOmsService(requestParams);
  } catch(error){
    console.log(error)
  }
  
}
const getDraftRequestProcessorOrders = async (
  requesterAccountId,
  payload = {},
) => {
  const queryString = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "description",
    orderBy: "asc",
  });

const requestParams = {
  method: "GET",
  url: `${appConfig.v2.documentRequest.draftOrders.replace(
    "{requesterAccountId}",
    requesterAccountId,
  )}?${queryString}`,
};

  return await queryOmsService(requestParams);
};

const deleteOrderDraft = async (orderDraftId) => {
  const requestParams = {
    method: "STRICT_DELETE",
    url: appConfig.v2.documentRequest.deleteOrderDraft.replace(
      "{orderDraftId}",
      orderDraftId,
    ),
  };
  return await invokeOmsService(requestParams);
};

const orderservice ={
  getRequestorOrdersWithFilesByRequestStatus,
  getRequestProcessorOrdersByInternalStatus,
  getRequestorOrdersByRequestStatus,
  getNewRequestProcessorDocuments,
  getBulkAssignmentOrders,
  getAllRequest,
  updateOrderSupportRequestProcessor,
  setRequesterSupportMessagesRead,
  getDraftRequestProcessorOrders,
  deleteOrderDraft,
}
export default orderservice